





























































import { defineComponent } from '@vue/composition-api';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { actOnGroupCampaignInvitation } from '@front-app/services/GroupInvitationCampaignApi/GroupsInvitationApi';
import { GroupRoleRequest } from '@front-app/services/GroupsApi/GroupsMemberApi';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size, Spacing } from '@front-app/components/constants';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import StandardErrorText from '@front-app/components/cards/state/StandardErrorText.vue';

export default defineComponent({
	components: {
		CtaButton,
		SimpleCard,
		StandardErrorText,
	},
	props: {
		email: {
			type: String,
			required: false,
			default: '',
		},
		inviteId: {
			type: String,
			required: false,
			default: '',
		},
	},
	setup(props) {
		const {
			track,
			isError,
			isSuccess,
			isLoading,
		} = useAsyncStatus();
		const declineInvitation = () => {
			if (!props.inviteId) {
				return;
			}
			track(actOnGroupCampaignInvitation({
				inviteId: props.inviteId,
				action: GroupRoleRequest.DECLINE,
			}));
		};
		return {
			declineInvitation,
			isError,
			isSuccess,
			isLoading,
			// Util
			declineButtonSize: Size.LARGE,
			declineButtonPalette: ButtonPalettes.PRIMARY,
			cardSpacing: Spacing.LOOSE,
		};
	},
});
